import React from "react";
import silverwareImage from '../../images/bijoux.PNG';
import CategoryPage from '../CategoryPage';

function ArgenteriePage() {
    const details = [
        "Services à thé et à café en argent",
        "Plateaux en argent",
        "Coupes et compotiers",
        "Salerons et poivriers",
        "Pichets et carafes en argent",
        "Candelabres et bougeoirs",
        "Couvertures de service",
        "Chandeliers",
        "Services de table (fourchettes, couteaux, cuillères)",
        "Verres à vin et à liqueur en argent",
        "Boîtes à cigarettes et étuis",
        "Bols en argent",
        "Vases en argent",
        "Pots à lait et sucriers",
        "Paniers et corbeilles en argent",
        "Coffrets et boîtes à bijoux",
        "Seaux à glace",
        "Médaillons et pendentifs en argent",
        "Plats de service",
        "Ménagères et couverts de présentation",
    ];

    return (
        <CategoryPage
            title="Argenterie Ancienne"
            image={silverwareImage}
            description="Je rachète avec passion l’art de la table et l’argenterie ancienne, quelle que soit leur condition. Que vos pièces présentent de la noirceur ou des traces du temps, elles ont une valeur précieuse. Je vous propose une évaluation juste et un prix avantageux, en tenant compte de l’authenticité et de la rareté de chaque objet. N’hésitez pas à me contacter pour vendre vos pièces d’argenterie, je les acquiers à des prix très compétitifs, même si elles sont abîmées."
            details={details}
        />
    );
}

export default ArgenteriePage;
